import * as React from "react";
import { Navigate, Outlet } from "react-router";
import { useAuth } from "@/features/auth/auth-context";
import { canAccessTraegerPortal } from "@/features/auth/role-utils";

/**
 * TraegerGate — guard für /traeger/* — leitet non-traeger-admin um.
 *
 * Server-side ist die finale source-of-truth (RequireTraegerAdmin
 * middleware in api/internal/http/middleware/tenant.go), aber der
 * client-side gate vermeidet 403-roundtrips für offensichtliche
 * fehlnavigationen + zeigt eine bessere fehlermeldung.
 */
export function TraegerGate(): React.ReactElement {
  const auth = useAuth();
  if (auth.status === "loading") {
    return (
      <main className="flex min-h-[40vh] items-center justify-center text-sm text-neutral-500">
        Lade …
      </main>
    );
  }
  if (!canAccessTraegerPortal(auth.user)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
